import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import {environment} from './environments/environment';

Sentry.init({
  dsn: environment.sentry.dsn,
  enabled: environment.sentry.enabled,
  environment: environment.sentry.environment,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: environment.sentry.tracesSampleRate,
  release: (window as any).__APP_RELEASE__,
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
